import DashboardHeader from "@/components/DashboardHeader";
import { Button } from "@thdinc/hpf-shared";
import React, { FC } from "react";
interface Props {
    previewVisible?: boolean;
    hideInvoice: boolean;
    onPreviewPress?: () => void;
}

const Header: FC<Props> = ({ onPreviewPress, previewVisible, hideInvoice = false }) => {
    return (
        <header className="w-full">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                <div className="min-w-0">
                    <div className="flex items-center gap-3 flex-wrap">
                        <DashboardHeader title="Contract" />
                    </div>
                    <p className=" text-gray-600 text-xs leading-relaxed max-w-md">
                        Happiest Ours shall not be held responsible or liable for any content, terms, or information uploaded or included in the contract.
                    </p>
                </div>
                <div className="flex flex-row flex-wrap justify-center sm:justify-end gap-2 sm:gap-3 md:gap-4 md:shrink-0">
                    <Button
                        style={{ 'display': hideInvoice ? 'none' : 'block' }}
                        onClick={onPreviewPress}
                        type="button"
                        classes="bg-black text-white flex items-center justify-center gap-2 px-4 py-2 lg:hidden"
                    >
                        {previewVisible ? "Hide Invoice" : "View Invoice"}
                    </Button>
                </div>
            </div>
        </header>
    );
};

export default Header;
